/*
 * Copyright (c) 2019 by DCCS GmbH. All rights reserved.
 */

/* eslint-env node */

// eslint-disable-line import/no-unassigned-import

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import moment from 'moment';

import App from './components/App.vue';

import '../css/app.scss';

require('@babel/polyfill'); // eslint-disable-line import/no-unassigned-import

require('moment/locale/de'); // eslint-disable-line import/no-unassigned-import

Vue.prototype.$http = axios.create();
window.Bus = new Vue({ name: 'Bus' });
Vue.config.errorHandler = function(err, vm, info) {
  console.error(err);
};

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: '',
    invalid: 'is-danger',
  },
});

Vue.directive('autofocus', {
  inserted: el => {
    el.focus();
  },
});

moment().locale('de');

window.dccs = window.dccs || {};
const modules = [];

/* Modules.push(() => {
  if (document.getElementById('app-login') !== null) {
  Vue.mixin(translateMixin);
  Vue.mixin(provinceMixin);
  Vue.mixin(insuranceMixin);

  window.dccs.LoginApp = new Vue({
    el: '#app-login',
    components: { Login },
  });
}
});*/

modules.push(() => {
  if (document.getElementById('app-klv-login') !== null) {
    Vue.prototype.$http = axios.create({
      baseURL: '',
    });

    Vue.use({
      install(V) {
        const bus = new Vue();
        V.prototype.$bus = bus;
        V.bus = bus;
      },
    });

    // eslint-disable-next-line no-new
    new Vue({
      el: '#app-klv-login',

      data() {
        return {};
      },

      render: h => h(App),
    });
  }
});

window.dccs.init = () => {
  modules.forEach(module => {
    console.log('calling module', module);
    module();
  });
};

if (window.Liferay) {
  window.Liferay.on('endNavigate', event => {
    if (!window.dccs.LoginApp) {
      // Window.dccs.init();
      window.location.reload();
    }
  });
}
